import React from 'react'
import styled, { css } from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type Size = 'md' | 'sm' | 'xs'

type Props = {
  name: string
  color: string
  size?: Size
  favoriteSlot?: React.ReactNode
} & ClassNameProps &
  Omit<React.ComponentPropsWithoutRef<'div'>, 'children' | 'color'>

export const WalletShort: React.FC<Props> = ({
  name,
  color,
  size = 'md',
  favoriteSlot,
  className,
  ...rest
}) => {
  return (
    <Root className={className} $size={size} {...rest}>
      {favoriteSlot}
      <Indicator style={{ backgroundColor: color }} />
      <Name>{name}</Name>
    </Root>
  )
}

const Root = styled.div<{ $size: Size }>`
  display: grid;
  align-items: center;
  overflow: hidden;
  grid-auto-flow: column;
  justify-content: start;
  --gap: var(--wallet-short-gap);
  --indicator-size: var(--wallet-short-indicator-size, 6px);

  ${({ $size }) => {
    switch ($size) {
      case 'xs': {
        return css`
          gap: var(--gap, 4px);
          font-size: 12px;
        `
      }
      case 'sm': {
        return css`
          gap: var(--gap, 8px);
          font-size: 14px;
          line-height: 20px;
        `
      }
      case 'md': {
        return css`
          gap: var(--gap, 8px);
          font-size: 16px;
          line-height: 20px;
        `
      }
    }
  }}

  font-weight: 600;
`

const Indicator = styled.div`
  width: var(--indicator-size);
  height: var(--indicator-size);
  border-radius: 50%;
`

const Name = styled.div`
  color: var(--text-12);

  overflow-wrap: break-word;
  display: block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
